import * as Sentry from '@sentry/sveltekit';
import posthog from 'posthog-js';

import { invalidateAll } from '$app/navigation';

import { analytics } from '$lib/analytics';
import { Bench } from '$lib/bench';
import { Repo, SQLocalRepo } from '$lib/client/repo';
import { clientRepo } from '$lib/states/client-repo.svelte';

export function tryCreateClientRepo() {
	try {
		clientRepo.update({ status: 'initializing' });
		const repo = new SQLocalRepo({
			onError(error) {
				clientRepo.update({ status: 'error', error });
			},
			onInit() {
				clientRepo.update({ status: 'connecting' });
			},
			onConnect() {
				clientRepo.update({ status: 'preparing' });
			},
			onReady() {
				clientRepo.update({
					status: 'ready',
					repo: new Repo(repo)
				});

				invalidateAll();
				identifyInstance();

				const measurement = Bench.measure('db.ready', 'document.head');
				analytics.capture({
					category: 'app',
					target: 'client_repo',
					verb: 'initialize',
					data: {
						durataion: measurement.duration
					}
				});
			}
		});
	} catch (cause) {
		const error = new Error('Failed to create client repository', { cause });
		clientRepo.update({ status: 'error', error });
	}
}

async function identifyInstance() {
	const instance = await clientRepo.repo?.getInstance();
	if (!instance) {
		return;
	}

	Sentry.setUser({ id: instance.seed });
	posthog.identify(instance.seed, {
		instanceCreatedAt: instance.createdAt
	});
}
